export default __webpack_public_path__ + "static/media/add-to-selected-2.c534fc56.svg";